import { Divider, Typography } from "@mui/material";
import React from "react";
import useStyles from "./pageTitleStyle";
function PageTitle(props) {
  const classes = useStyles();
  return (
    <div>
      <Typography
        variant="h6"
        color="primary"
      
        component="div"
        className={classes.title}
      >
        {props.title}
      </Typography>
    {props.showDivider?  <Divider  sx={{  marginBottom:3,}}/>:null}
    </div>
  );
}

export default PageTitle;
